import React from 'react';
import { useUIStore } from '../../../../stores/uiStore';
import { getTranslation } from '../../../../i18n';

interface TableEmptyRowProps {
  title?: string;
  description?: string;
  /** 'filter' = user must apply filters first; 'empty' = no data matches */
  variant?: 'empty' | 'filter';
}

const EmptyIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="4" y="8" width="24" height="18" rx="3" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M4 13h24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 18.5h4M10 22h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M22 19.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z" stroke="currentColor" strokeWidth="1.5" />
    <path d="M25.5 24l2 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const FilterIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M5 9h22M9 16h14M13 23h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const TableEmptyRow = ({
  title,
  description,
  variant = 'empty',
}: TableEmptyRowProps) => {
  const { language } = useUIStore();
  const t = (key: string) => getTranslation(language, key);

  const defaultTitle = variant === 'filter'
    ? t('amlEmptyStateApplyFiltersToLoadData')
    : t('amlEmptyStateNoResultsFound');
  const defaultDescription = variant === 'filter'
    ? t('amlEmptyStateApplyFiltersDesc')
    : t('amlEmptyStateNoResultsDesc');

  return (
    <div className="flex flex-col items-center justify-center py-14 animate-fade-in">
      <div className="w-14 h-14 rounded-2xl bg-brand/10 border border-brand/20 flex items-center justify-center text-brand/60 mb-3">
        {variant === 'filter' ? <FilterIcon /> : <EmptyIcon />}
      </div>
      <p className="text-sm font-semibold text-content mb-1">{title ?? defaultTitle}</p>
      <p className="text-xs text-content-muted leading-relaxed">{description ?? defaultDescription}</p>
    </div>
  );
};

export default TableEmptyRow;
